const news = () => {
    $newsList = $(".news-list")
    if (!$newsList) return;

    $newsList.slick({
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        arrows: false,
        infinite: true,
        centerMode: true,
        mobileFirst: true,
        responsive: [
            {
               breakpoint: 1023,
               settings: "unslick"
            }
         ]
    });

}

module.exports = news